import * as React from 'react';

import { RouteComponentProps } from 'react-router';
import * as RB from 'react-bootstrap';
import * as IntlR from 'react-intl'

import * as DTO from '../service/DTOs';
import * as API from '../service/apisvc';
//import { NumberFormat } from 'react-number-format';
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { SecurityListItem } from './view/LookupListItems';
import * as TF from '../service/tradeflow';
import * as Actions from '../service/Actions';
import * as Dispatch from '../service/Dispatcher';

import Cleave from 'cleave.js/react';
import moment from 'moment';

import { CAInstrumentLimitMargin, CAInstrumentLimitMarginPropsState } from './view/CAInstrumentLimitMargin';

import 'isomorphic-fetch';


export interface DoMRowContextLimitsState {
    marginpick?: DTO.NotesContragentMarginPick,
    margin?: DTO.NotesContragentMargin,

    modified: boolean;
    haserrors: boolean;
    error?: string;
    result?: string;

    loading: boolean;
    processing?: boolean;
    isSubmitting: boolean;
}

type DoMRowContextLimitsProps = DoMRowContextLimitsState & { xsrfToken?: string }
    & { instrument: DTO.InstrumentHead }
    & { domrecord: DTO.DomRecord}
    ;

export const initialState_DoMRowContextLimits: DoMRowContextLimitsState = {
    loading: false,
    isSubmitting: false,
    modified: false,
    haserrors: false
}

export class DoMRowContextLimits extends React.Component<DoMRowContextLimitsProps, DoMRowContextLimitsState> {
    //caFilter: MatrixFormFilter<DTO.EntityDto> | null;
    constructor(props: DoMRowContextLimitsProps) {
        super(props);
        this.appendLimit.bind(this);
        this.state = { ...initialState_DoMRowContextLimits };
        this.processMarginChange.bind(this);

        this.reloadContextLimits(props);
    }

    getDirection() {
        let directionDoM = this.props.domrecord.buylots && this.props.domrecord.buylots > 0 ? 'buy' : 'sell';
        return directionDoM == 'buy' ? 'give' : 'take';
    }

    reloadContextLimits(props: DoMRowContextLimitsProps){
        if (props.domrecord.contragent_info) {
            let directionDoM = props.domrecord.buylots && props.domrecord.buylots > 0 ? 'buy' : 'sell';
            let directionLim = directionDoM == 'buy' ? 'give' : 'take';
            let give = directionLim === 'give';

            this.loadContextLimits(props.domrecord.contragent_info.id, give)
                .then(data => {
                    if (data) {
                        let u = data.margins.map(x => Object.assign({}, x)).find(obj => { return obj.idinstrument== this.props.instrument.id });
                        //console.log('loadContextLimits - OK');
                        //console.log(data);
                        //console.log(u);


                        this.setState({ margin: data, marginpick: data.margins.map(x => Object.assign({}, x)).find(obj => { return obj.idinstrument == this.props.instrument.id }) });
                    }
                    else {
                        //console.log('loadContextLimits - NO DATA');
                        this.setState({ margin: data, marginpick: undefined });
                    }
                })
                .then(data => {
                    return;
                })
                .catch(reason => {
                    console.log('loadContextLimits - ERR');
                    console.log(reason);
                    this.setState({ margin: undefined, marginpick: undefined });
                });
        }
    }

    //handleSelectContextCa(locatorId?: string, record?: DTO.EntityDto) {
    //    if (this.caFilter)
    //        this.caFilter.handleSelectContext(locatorId, record);
    //}

    //handleRemoveCa(locatorId?: string, record?: DTO.EntityDto) {
    //    if (this.caFilter)
    //        this.caFilter.handleRemove(locatorId, record);
    //}

    //dispatchCaFilterSettings = (action: Actions.FilterSettingsAction) => {
    //    if (action.type == 'RESET_FILTERSETTINGS_MODIFICATION_FORM') {
    //        if (this.caFilter) {
    //            this.caFilter.typeahead.getInstance().clear();
    //        }
    //    }

    //    if (this.caFilter) {
    //        return Dispatch.FilterSettingsDispatcher(this.caFilter, action);
    //    }

    //    return {};
    //}

    //processAppendCA(entity: DTO.EntityDto) {
    //    let manipulation: DTO.ManipulationAction<string> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_FILTER_INCLUDE,
    //        locatorId: '' + entity.id,
    //        payload: undefined
    //    }

    //    return Actions.caFilterActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    //}

    //processRemoveCA(entity: DTO.EntityDto) {
    //    let manipulation: DTO.ManipulationAction<string> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_FILTER_EXCLUDE,
    //        locatorId: '' + entity.id,
    //        payload: undefined
    //    }

    //    return Actions.caFilterActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    //}


    loadContextLimits(idcontragent: number, give: boolean): Promise<DTO.NotesContragentMargin | undefined> {
        let _that = this;
        const url:string = give ? API.API_CALIMITSGIVE_URL : API.API_CALIMITSTAKE_URL;

        return new Promise(function (resolve, reject) {
            fetch(API.apiUrl(url + '/' + idcontragent), {
                method: 'GET',
                credentials: 'include',
                headers: new Headers({
                    ...{ 'X-XSRF-TOKEN': _that.props.xsrfToken || '' },
                    ...API.authHeader()
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json() as Promise<DTO.MessageDto<DTO.NotesContragentMargin>>
                    } else {
                        var error = new Error(response.statusText);
                        throw error;
                    }
                }
                )
                .then(data => {
                    return resolve(data.result);
                })
                .catch(reason => {
                    console.log(reason);
                    reject(reason);
                });
        });
    }



    //renderElementCa(data: DTO.EntityDto, idx: number) {

    //    return <EntityListItem key={'elemlistitem_' + idx} entity={data} />
    //};

    applyLimitChange = (event: React.FormEvent<RB.Form>) => {
        if (this.state.marginpick) {
            //console.log(this.state.marginpick);
            //console.log('applyLimitChange');
            this.submitApplyLimitChangeForm(this.state.marginpick);            
        }

        event.preventDefault();
    }

    appendLimit = (event: React.FormEvent<RB.Form>) => {
        //event.preventDefault();

        if (!this.state.marginpick) {
            let newmp: DTO.NewNotesContragentMarginPick = {
                idinstrument: this.props.instrument.id,
                //idcurrency: this.props.instrument.currency.id,
                //idduration: this.props.instrument.duration.id,
                givemargin: 0
            }
            this.submitAppendLimitForm(newmp);
        }

        event.preventDefault();
    }

    dispatchCaLimit = (action: Actions.ContragentLimitsAction) => {
        if (action.type == 'RESET_CONTRAGENTLIMITS_MODIFICATION_FORM') {
            //if (this.caFilter) {
            //    this.caFilter.typeahead.getInstance().clear();
            //}
        }

        //if (this.caFilter) {
        //    return Dispatch.ContragentLimitsStateForwarder(this.caFilter, action);
        //}

        return {};
    }

    processApplyLimitChange(marginpick: DTO.NotesContragentMarginPick) {
        if (this.state.margin && this.props.domrecord.contragent_info) {
            let _marginpl = this.state.margin;
            _marginpl.margins = [marginpick];

            let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
                locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
                type: DTO.MANIPULATION_PERM_ELEMENT_CHANGE,
                locatorId: '' + marginpick.id,
                payload: _marginpl
            }

            return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaLimit);
        }
    }

    processAppendLimit(newmarginpick: DTO.NewNotesContragentMarginPick) {

        if (this.props.domrecord.contragent_info) {

            let pick: DTO.NotesContragentMarginPick = {
                idinstrument: newmarginpick.idinstrument,
                //idcurrency: newmarginpick.idcurrency,
                //idduration: newmarginpick.idduration,
                givemargin: newmarginpick.givemargin,
                free2givedeal: 0,
                free2giveorder: 0,
                givendeal: 0,
                givenorder: 0,
                id: 0                
            };

            let marginpl: DTO.NotesContragentMargin;
            if (this.state.margin) {
                marginpl = this.state.margin;
                //marginpl.margins.push(pick);
                marginpl.margins = [pick];
            }
            else {
                marginpl = {
                    idcontragent: this.props.domrecord.contragent_info.id,
                    alertnote: '',
                    allowed: true,
                    margins: [pick]
                }
            }

            let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
                locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
                type: DTO.MANIPULATION_PERM_ELEMENT_APPEND,
                locatorId: '0',
                payload: marginpl
            }

            return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaLimit);
        }
    }

    submitApplyLimitChangeForm = (marginpick: DTO.NotesContragentMarginPick) => {
        return (async () => {
            try {
                this.setState({ isSubmitting: true });

                await this.processApplyLimitChange(marginpick);

                this.reloadContextLimits(this.props);

            } catch (error) {
                //this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, result: error.message || 'Произошла ошибка' } });
            }
            finally {
                this.setState({ isSubmitting: false });
            }

        })();
    }

    submitAppendLimitForm = (newmp: DTO.NewNotesContragentMarginPick) => {
        return (async () => {
            try {
                this.setState({ isSubmitting: true });

                await this.processAppendLimit(newmp);

                this.reloadContextLimits(this.props);

                //if (this.props.domrecord.contragent_info) {
                //    let _margin = await this.loadContextLimits(this.props.domrecord.contragent_info.id);
                //    if (_margin)
                //        this.setState({ margin: _margin,  marginpick: _margin.margins.find(obj => { return obj.idcurrency == this.props.instrument.currency.id && obj.idduration == this.props.instrument.duration.id }) });
                //    else
                //        this.setState({ margin: _margin,  marginpick: undefined });
                //}
                //else {
                //    this.setState({ margin: undefined ,  marginpick: undefined });
                //}

            } catch (error) {
                //this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, result: error.message || 'Произошла ошибка' } });
            }
            finally {
                this.setState({ isSubmitting: false });
            }

        })();
    }

    processMarginChange(newgivemargin: number | undefined) {
        if (this.state.marginpick) {
            let mp = this.state.marginpick;
            mp.givemargin = newgivemargin ? newgivemargin : 0;
            this.setState({ marginpick: mp});
        }
    }

    renderFilterTableCa(records: DTO.EntityDto[], processing: boolean, rowRenderer: (data: DTO.EntityDto, selected_locatorId?: string) => JSX.Element, selected_locatorId?: string) {
        return <table className='table table-header-fixed table-fix-H-200 table-condensed'>
            <thead>
                <tr style={{ width: 'calc(100% - 10px)' }}>
                    <th style={{ textAlign: 'right', width: '30%' }}>Reuter Code</th>
                    <th style={{ textAlign: 'right', width: '20%' }}>Краткое название</th>
                    <th style={{ textAlign: 'right', width: '50%' }}>Полное название</th>
                </tr>
            </thead>
            <tbody style={{ height: '145px' }}>
                {records.map(sec =>
                    rowRenderer(sec, selected_locatorId)
                )}

            </tbody>
        </table>;
    }

    public render() {
        let myOwn = this.props.domrecord.hasownedrecs ? this.props.domrecord.hasownedrecs : false;
        let direction = this.getDirection();
        let directionLim = direction == 'give' ? 'Продажу' : 'Покупку';


        //console.log('this.props');
        //console.log(this.props);

        //let FilterSec: new () => MatrixFormFilter<DTO.Security> = C;

        //const MatrixSecurityFilter = MatrixFormFilter as MatrixSecurityFilter;
        //const MatrixContragentFilter = MatrixFormFilter as MatrixContragentFilter;

        let contextGiveMarginsToCA = !this.state.loading && this.state.marginpick ?
            <CAInstrumentLimitMargin key={'CAInstrumentGiveMargin'} instrument={this.props.instrument} showCurrency={true} showInstrument={true}
                marginpick={this.state.marginpick} editMargin={true} compact={false} twolines={false}
                processMarginChange={this.processMarginChange.bind(this)}
                />
            : <p><em>Processing...</em></p>;

        let contextTakeMarginsToCA = !this.state.loading && this.state.marginpick ?
            <CAInstrumentLimitMargin key={'CAInstrumentTakeMargin'} instrument={this.props.instrument} showCurrency={true} showInstrument={true}
                marginpick={this.state.marginpick} editMargin={false} compact={false} twolines={false}
            processMarginChange={this.processMarginChange.bind(this)}
            />
            : <p><em>Processing...</em></p>;

        let resultCap =
            this.state.isSubmitting ?
                <div>{"Отправка данных"}</div>
                : !this.state.processing ?
                    (this.state.result === undefined ? ""
                        : !this.state.haserrors ?
                            <div><RB.Glyphicon glyph="glyphicon glyphicon-ok" />{" "}{this.state.result}</div>
                            : <div><RB.Glyphicon glyph="glyphicon glyphicon-exclamation-sign" />{" "}{this.state.error}</div>
                    )
                    : "";

        let changesMade = false;

        if (this.state.margin && this.state.marginpick) {
            let refMargin = this.state.margin.margins.find(obj => { return obj.idinstrument == this.props.instrument.id });
            if (refMargin) {
                changesMade = refMargin.givemargin != this.state.marginpick.givemargin;
            }
        }


        let applyLimit =
            <RB.Row>
                <RB.Col sm={12} >
                    <RB.Form horizontal method="post" onSubmit={this.applyLimitChange} autoComplete="off">
                        <input type="hidden" name="requestVerificationToken" defaultValue={this.props.xsrfToken} />
                        <fieldset>
                            <RB.FormGroup >

                                <RB.Col sm={6}>
                                    <div style={{ fontSize: '12px' }}>
                                        {'' /*this.props.instrument.name*/}
                                    </div>
                                </RB.Col>

                                <RB.Col sm={5} smOffset={1} className="text-center">
                                    <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.isSubmitting || (this.state.marginpick == undefined) || !changesMade}>
                                        {'Сохранить'}
                                    </RB.Button>
                                </RB.Col>
                            </RB.FormGroup>
                            <RB.FormGroup>
                                <RB.Col sm={12} className="text-center">
                                    <div>
                                        {resultCap}
                                    </div>
                                </RB.Col>
                            </RB.FormGroup>

                        </fieldset>
                    </RB.Form>
                </RB.Col>
            </RB.Row>

        
        let appendLimit = 
            <RB.Row>
                <RB.Col sm={12} >
                    <RB.Form horizontal method="post" onSubmit={this.appendLimit} autoComplete="off">
                        <input type="hidden" name="requestVerificationToken" defaultValue={this.props.xsrfToken} />
                        <fieldset>
                            <RB.FormGroup >

                                <RB.Col sm={6}>
                                    <div style={{ fontSize: '12px' }}>
                                        {''}
                                    </div>
                                </RB.Col>

                                <RB.Col sm={5} smOffset={1} className="text-center">
                                    <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.isSubmitting || (this.state.marginpick != undefined)}>
                                        <RB.Glyphicon glyph="plus" />{' Добавить'}
                                    </RB.Button>
                                </RB.Col>
                            </RB.FormGroup>
                            <RB.FormGroup>
                                <RB.Col sm={12} className="text-center">
                                    <div>
                                        {resultCap}
                                    </div>
                                </RB.Col>
                            </RB.FormGroup>

                        </fieldset>
                    </RB.Form>
                </RB.Col>
            </RB.Row>

        return <div ref="contextLimitsRef" className="otc-trade">
            <RB.Row>
                <RB.Col sm={12}>
                    <RB.Well bsSize="sm" className='otc-filter-panel'>
                        <div>
                            <div style={{ fontSize: '14px' }}><b>{'Лимиты на '}{directionLim}</b></div>
                        </div>
                        {this.props.domrecord.contragent_info ? 
                            <div>
                                <div>
                                    <span><strong>{'Контрагент: '}</strong>{this.props.domrecord.contragent_info.shortname}{' ('}{this.props.domrecord.contragent_info.fullname}{')'}</span>
                                    <br />
                                </div>
                                {!this.state.marginpick ?
                                    <div>
                                        {direction == 'give' ?
                                            <span><strong>{'У вас нет действующего лимита на '}{this.props.instrument.name}{' для данного контрагента'}</strong></span>
                                            :
                                            <span><strong>{'У контрагента нет на вас действующего лимита для '}{this.props.instrument.name}</strong></span>
                                        }
                                        
                                        {direction == 'give' ? appendLimit : undefined}
                                    </div>
                                    :
                                    <div>
                                        {direction == 'give' ? contextGiveMarginsToCA : contextTakeMarginsToCA}
                                        {direction == 'give' ? applyLimit : undefined}
                                    </div>

                                }                                
                            </div>
                            : 
                            <div>
                                <span><strong>{'Контрагент скрыл от вас свое имя'}</strong></span>
                                <br />
                            </div>
                        }
                    </RB.Well>

                </RB.Col>
            </RB.Row>

        </div>;
    }
};